export default __webpack_public_path__ + "static/media/runningmanmarquee-blue.ff2cb09e.jpg";